{
  "point": "punto",
  "points": "puntos",
  "credits": "créditos",
  "loyaltyCredit": "Crédito de Loyalty",
  "statusPoints": "Puntos de estado",
  "balancePoints": "Puntos para gastar",
  "edit": "Editar",
  "delete": "Eliminar",
  "copyOf": "Copia de {value}",
  "numberedCopyOf": "Copia {index} de {value}",
  "total": "total",
  "uplift": "aumento",
  "approveBtn.label": "Ok",
  "cancelBtn.label": "Cancelar",
  "createBtn.label": "Crear",
  "saveBtn.label": "Guardar",
  "searchBtn.label": "Buscar",
  "updateBtn.label": "Actualizar",
  "applyBtn.label": "Aplicar",
  "addNewPlanBtn.label": "Añadir plan",
  "launchPlanBtn.label": "Lanzar plan",
  "toOverviewBtn.label": "Ir a resumen",
  "collapseBtn.label": "Ocultar",
  "extendBtn.label": "Detalles ",
  "updateAndSave.label": "Actualizar y guardar",
  "pleaseConfirmBtn.label": "Confirmar",
  "closeBtn.label": "Cerrar",
  "resetBtn.label": "Restablecer",
  "confirmBtn.label": "Confirmar",
  "status.inactive": "Inactivo",
  "status.active": "Activo",
  "status.deactivated": "Desactivado",
  "status.scheduled": "Programado",
  "status.expired": "Vencido",
  "status.readyToUse": "Listo para utilizar",
  "status.readyToLaunch": "Listo para lanzar",
  "status.empty": "Vacío",
  "status.activity.pending": "Pendiente",
  "status.activity.confirmed": "Confirmado",
  "status.activity.expired": "Vencido",
  "status.activity.canceled": "Cancelado",
  "status.activity.removed": "Eliminado",
  "status.default": "Valor predeterminado",
  "action.promotion": "Promoción",
  "action.referral": "Recomendación",
  "action.action": "Acción",
  "tiers.numberOfPurchases.plural.zero": "{number} compras",
  "tiers.numberOfPurchases.plural.one": "{number} compra",
  "tiers.numberOfPurchases.plural.two": "{number} compras",
  "tiers.numberOfPurchases.plural.few": "{number} compras",
  "tiers.numberOfPurchases.plural.many": "{number} compras",
  "tiers.numberOfPurchases.plural.other": "{number} compras",
  "validity.unlimited": "Sin límite",
  "validity.limitedFromEarn.value.days.plural.zero": "{number} días",
  "validity.limitedFromEarn.value.days.plural.one": "{number} día",
  "validity.limitedFromEarn.value.days.plural.two": "{number} días",
  "validity.limitedFromEarn.value.days.plural.few": "{number} días",
  "validity.limitedFromEarn.value.days.plural.many": "{number} días",
  "validity.limitedFromEarn.value.days.plural.other": "{number} días",
  "validity.limitedFromEarn.value.weeks.plural.zero": "{number} semanas",
  "validity.limitedFromEarn.value.weeks.plural.one": "{number} semana",
  "validity.limitedFromEarn.value.weeks.plural.two": "{number} semanas",
  "validity.limitedFromEarn.value.weeks.plural.few": "{number} semanas",
  "validity.limitedFromEarn.value.weeks.plural.many": "{number} semanas",
  "validity.limitedFromEarn.value.weeks.plural.other": "{number} semanas",
  "validity.limitedFromEarn.value.months.plural.zero": "{number} meses",
  "validity.limitedFromEarn.value.months.plural.one": "{number} mes",
  "validity.limitedFromEarn.value.months.plural.two": "{number} meses",
  "validity.limitedFromEarn.value.months.plural.few": "{number} meses",
  "validity.limitedFromEarn.value.months.plural.many": "{number} meses",
  "validity.limitedFromEarn.value.months.plural.other": "{number} meses",
  "days": "Días",
  "dayInMonth": "Día",
  "month": "Mes",
  "months.1": "Enero",
  "months.2": "Febrero",
  "months.3": "Marzo",
  "months.4": "Abril",
  "months.5": "Mayo",
  "months.6": "Junio",
  "months.7": "Julio",
  "months.8": "Agosto",
  "months.9": "Septiembre",
  "months.10": "Octubre",
  "months.11": "Noviembre",
  "months.12": "Diciembre",
  "form.missingSettingsAlert": "Asegúrese de introducir toda la información necesaria antes de guardar y continuar con el siguiente paso.",
  "noResults.title": "No se han encontrado resultados.",
  "noResults.text": "No se han encontrado resultados para su búsqueda \"{text}\".",
  "alertContainer.editModeAlert.message": "Está editando la siguiente versión de su plan de Loyalty. Sus cambios surtirán efecto después de lanzar esta nueva versión. ",
  "alertContainer.liveModeAlert.message.linkText": "Más información",
  "alertContainer.liveModeAlert.message": "Para editar niveles, fijos y beneficios adicionales, desde la gestión de Loyalty, seleccione Actualizar y lanzar, y luego cambie a Editar siguiente versión.{link}",
  "card.isRoadmap.text": "Roadmap",
  "catalogSelector.tooManyResults.title": "Hay demasiados resultados para esta búsqueda. ",
  "catalogSelector.tooManyResults.text": "Vuelva a realizar la búsqueda con palabras clave más específicas para restringir los resultados.",
  "catalogSelector.errorAlert": "Algo salió mal. Vuelva a intentarlo.",
  "catalogSelector.searchPlaceholder.byItem": "Busque un producto específico.",
  "catalogSelector.searchPlaceholder.byCatOrBrand": "Seleccione marcas o categorías específicas que desee promocionar.",
  "catalogSelector.checkAllItems.label": "Seleccionar todo",
  "catalogSelector.showAllSelections.label": "Muestre solo los elementos seleccionados.",
  "catalogSelector.cancelBtn.label": "Cerrar",
  "catalogSelector.saveBtn.label": "Aplicar y guardar",
  "catalogSelector.brands.plural.zero": "{number} marcas",
  "catalogSelector.brands.plural.one": "{number} marca",
  "catalogSelector.brands.plural.two": "{number} marcas",
  "catalogSelector.brands.plural.few": "{number} marcas",
  "catalogSelector.brands.plural.many": "{number} marcas",
  "catalogSelector.brands.plural.other": "{number} marcas",
  "catalogSelector.category.plural.zero": "{number} categorías",
  "catalogSelector.category.plural.one": "{number} categoría",
  "catalogSelector.category.plural.two": "{number} categorías",
  "catalogSelector.category.plural.few": "{number} categorías",
  "catalogSelector.category.plural.many": "{number} categorías",
  "catalogSelector.category.plural.other": "{number} categorías",
  "catalogSelector.product.plural.zero": "{number} productos",
  "catalogSelector.product.plural.one": "{number} producto",
  "catalogSelector.product.plural.two": "{number} productos",
  "catalogSelector.product.plural.few": "{number} productos",
  "catalogSelector.product.plural.many": "{number} productos",
  "catalogSelector.product.plural.other": "{number} productos",
  "confirmNavDialog.discardChanges.text": "Asegúrese de guardar los cambios. Si abandona esta página, los cambios que no haya guardado se perderán.",
  "confirmNavDialog.approveBtn.label": "OK",
  "confirmNavDialog.cancelBtn.label": "Cancelar",
  "actionDashboard.overviewLinkText.referral": "Ir a acciones de recomendación",
  "actionDashboard.editLinkText": "Editar programa",
  "dashboardOptions.launchedAt": "Programa lanzado el: ",
  "dashboardOptions.currentlyShowingLabel": "Se está mostrando actualmente:",
  "dashboardOptions.viewLabel": "Visualizar:",
  "masterActions.join.largeText": "Unirse a Loyalty",
  "masterActions.purchases.largeText": "Compra",
  "status.inactive.tooltip": "Las opciones no se han completado.",
  "status.inactive.tooltip.proomotionEnded": "Esta promoción está inactiva y no se puede editar. Puedes copiar la promoción o crear una nueva.",
  "status.inactive.tooltip.connectedToRewardPools": "El conjunto de vales {name} tiene el estado {status}.",
  "status.inactive.tooltip.invalidPromotionRecurringDates": "Verifique las fechas de la promoción.",
  "status.readyToUse.tooltip.promotion": "La promoción está lista para su uso. Puede mostrar automáticamente la promoción en la cartera del miembro o adjuntarla a los miembros en el editor de la campaña utilizando tokens de Loyalty.",
  "status.readyToUse.tooltip.attachable": "La acción está lista para su uso y puede adjuntarse a los contactos a través del editor de la campaña utilizando los tokens de Loyalty.",
  "status.active.tooltip.promotion": "Esta promoción está activa y disponible para todos los miembros.",
  "status.active.tooltip.attachable": "Esta acción está activa. No puede modificar las opciones. Para editar esta acción, primero desactívela y espere a la fecha de vencimiento especificada. También puede copiar la acción, editar la copia y lanzar la copia como una nueva acción.",
  "status.active.tooltip.event": "Esta acción está activa. Puede conectar la acción a beneficios o al programa de automatización.",
  "status.deactivated.tooltip.promotion": "Ha desactivado esta promoción y ya no está disponible para los miembros.",
  "status.deactivated.tooltip.attachable": "Ha desactivado esta acción. Para editar o eliminar esta acción, debe esperar a la fecha de vencimiento especificada. También puede copiar la acción, editar la copia y lanzar la copia como una nueva acción.",
  "editorTypePopup.title": "Seleccionar tipo de editor",
  "editorTypePopup.text": "Los clientes sin acceso exclusivo verán una página de bloqueo. Puede crear una página HTML personalizada o utilizar una de nuestras plantillas.",
  "editorTypePopup.options.html.text": "Crear página HTML personalizada",
  "editorTypePopup.options.template.text": "Crear página a partir de una plantilla",
  "fileInputField.uploadBtn.label": "Cargar",
  "fileInputField.browseBtn.label": "Navegar",
  "formStepsContainer.nextStep.text": "Siguiente paso",
  "formStepsContainer.prevStep.text": "Paso previo",
  "iconGallery.title": "Galería de iconos de Loyalty",
  "iconGallery.deleteDialog.headline": "¿Está seguro que desea eliminar este icono?",
  "iconGallery.deleteDialog.content": "Después de eliminar este icono, no será visible para los miembros. Asegúrese de que este icono no está conectado a ninguna acción o vale.",
  "iconGallery.uploadResult.successMessage": "Carga correcta.",
  "iconGallery.searchInput.placeholder": "Busque icono por nombre.",
  "iconGallery.fileUploader.tooltip": "<h3>Cargar</h3><b>Requisitos para cargar iconos:</b></br>Archivo: SVG o PNG</br>Formato: cuadrado<br>Dimensiones máximas: 200x200 píxeles<br>Tamaño de archivo máximo: 100 KB</br><sub>* Recomendamos un fondo transparente</sub>.",
  "multiLangPopup.defaultNoticeText": "Su idioma principal definido es el idioma predeterminado que ven los miembros, si no hay ninguna opción de idioma adecuada.",
  "multiLangPopup.defaultTitle.currency": "Conversión de moneda",
  "multiLangPopup.defaultTitle.language": "Traducción de idioma",
  "multiMarketSelector.multiSelectField.placeholder": "-- Seleccionar mercados --",
  "multiMarketSelector.selectField.placeholder": "-- Seleccionar mercado --",
  "multiPlanSelect.label": "Seleccionar su plan de Loyalty ",
  "preLaunchPopup.conditions.plan.title": "Opciones de plan",
  "preLaunchPopup.conditions.plan.text": "Verifique las opciones de su plan de Loyalty para asegurarse de que todo está configurado correctamente y coincide con las condiciones para los miembros.",
  "preLaunchPopup.conditions.tiers.title": "Niveles y beneficios",
  "preLaunchPopup.conditions.tiers.text": "Verifique que los niveles están configurados correctamente para todos los miembros y que su distribución de contactos en niveles coincide con su estrategia.",
  "preLaunchPopup.conditions.rewards.title": "Pooles de recompensas",
  "preLaunchPopup.conditions.rewards.text": "Verifique que ha cargado suficientes códigos de vales para todas las respuestas y que todos los pooles y la validez de los vales están definidos correctamente.",
  "preLaunchPopup.conditions.actions.title": "Acciones",
  "preLaunchPopup.conditions.actions.text": "Verifique que sus acciones cubren todas las tácticas que desea utilizar y que ha activado todas las acciones predeterminadas.",
  "preLaunchPopup.title": "¿Está seguro que desea lanzar su plan de Loyalty?",
  "preLaunchPopup.text": "Verifique sus opciones y asegúrese de que su plan de Loyalty plan está listo para lanzar:",
  "timeValidityInput.radioLabel.days": "Días",
  "timeValidityInput.radioLabel.weeks": "Semanas",
  "timeValidityInput.radioLabel.months": "Meses",
  "ctaUrl": "URL de CTA",
  "ctaText": "Texto de CTA",
  "message": "Mensaje",
  "pageNotFound": "No podemos encontrar la página que busca.",
  "externalEventSetup.title": "Eventos externos de Loyalty",
  "externalEventSetup.name.label": "Nombre del evento externo",
  "externalEventSetup.description.label": "Descripción",
  "externalEventSetup.description.tooltip": "Una descripción es interna y le ayuda a gestionar sus eventos de Loyalty.",
  "pointsRatesFields.perDescriptor.points": "ganado por",
  "catalog.item.type.category.name": "Categoría",
  "catalog.item.type.brand.name": "Marca",
  "catalog.item.type.item.name": "Product",
  "catalog.item.type.itemId.name": "ID de artículo",
  "exclusiveAccessOffers.options.fixedBenefit.title": "Acceso como beneficio fijo",
  "exclusiveAccessOffers.options.additionalBenefits.title": "Acceso como beneficio adicional",
  "exclusiveAccessOffers.options.action.title": "Acceso como recompensa por acción",
  "exclusiveAccessOffers.options.redemption.title": "Acceso por puntos",
  "exclusiveAccessOffers.options.redemptionForFree.title": "Acceso gratuito",
  "accessValidityType.options.unlimited.name": "El acceso es válido por tiempo ilimitado.",
  "accessValidityType.options.limitedFromEarn.name": "El acceso es válido durante un período de tiempo limitado a partir del momento en que el miembro lo obtiene.",
  "accessValidityType.options.fixedDate.name": "El acceso es válido durante un período de tiempo predefinido para todos los miembros.",
  "accessValidityType.options.disabled.fixedBenefit.name": "Desactive la disponibilidad de acceso como un beneficio fijo.",
  "accessValidityType.options.disabled.additionalBenefit.name": "Desactive la disponibilidad de acceso como un beneficio adicional.",
  "accessValidityType.options.disabled.reward.name": "Desactive la disponibilidad de acceso como recompensa por acción.",
  "createOfModify.options.create.name": "Activar oferta",
  "createOfModify.options.create.tooltip": "Al activar una nueva oferta, las reglas de la oferta activa se restablecen y están disponibles para los miembros de todos los niveles seleccionados durante el período de tiempo definido para la oferta.",
  "createOfModify.options.create.tooltip2": "Al activar una nueva oferta, las restricciones de las ofertas activas se restablecen y están disponibles para los miembros de todos los niveles seleccionados durante el período de tiempo definido para la oferta. ",
  "createOfModify.options.modify.name": "Editar oferta activa",
  "createOfModify.options.modify.tooltip": "Cuando edite una oferta activa, los cambios no afectarán a los usuarios que ya la hayan canjeado.",
  "exclusiveAccessFormSteps.exclusiveAccessPoolSettings.title": "Opciones de exclusividad",
  "exclusiveAccessFormSteps.exclusiveAccessBlockingEditor.title": "Página de bloqueo",
  "exclusiveAccessFormSteps.redemptionValue.title": "Acceso y ofertas",
  "exclusiveAccessFormSteps.EXCLUSIVE_ACCESS_VALIDITY.title": "Activación",
  "activityElementPointsText.loyalty": "{{points_name}}",
  "activityElementPointsText.pointsToSpend": "{{points_name}} a gastar",
  "activityElementPointsText.status": "Estado {{points_name}}",
  "activityElementPointsText.cashback": "Reembolso en efectivo",
  "activityElementPointsText.cashback.name": "{{cashback_name}}",
  "voucherTypeText.one_time": "Vale de un solo uso",
  "voucherTypeText.yearly": "Vale de varios usos",
  "exclusiveAccessTypeText.permanent": "Acceso exclusivo permanente",
  "exclusiveAccessTypeText.limitedTerm": "Acceso exclusivo por tiempo limitado",
  "mainTabs.dashboard.title": "Dashboard",
  "mainTabs.actions.title": "Acciones",
  "mainTabs.rewards.title": "Recompensas",
  "mainTabs.tiers.title": "Niveles",
  "mainTabs.loyaltyWallet.title": "Loyalty Wallet",
  "mainTabs.memberProfiles.title": "Perfiles de miembros",
  "mainTabs.externalEvents.title": "Eventos externos",
  "mainTabs.planSettings.title": "Opciones de plan",
  "mainTabs.vouchers.title": "Vales",
  "mainTabs.exclusiveAccesss.title": "Acceso exclusivo",
  "mainTabs.loyaltyManagement.title": "Gestión de Loyalty",
  "mainTabs.security.title": "Configuraciones de Loyalty ",
  "actionTabs.purchases.title": "Compras",
  "actionTabs.promotions.title": "Promociones",
  "actionTabs.engagements.title": "Fidelización",
  "actionTabs.events.title": "Eventos",
  "actionTabs.referral.title": "Recomendación",
  "actionTabs.join.title": "Unirse a Loyalty",
  "tierTabs.tiers.title": "Niveles",
  "tierTabs.fixedBenefits.title": "Beneficios fijos",
  "tierTabs.additionalBenefits.title": "Beneficios adicionales",
  "tierTabs.contactDistribution.title": "Gráfico de distribución",
  "managementTabs.accountSettings.title": "Opciones de cuenta",
  "managementTabs.languageAndCurrency.title": "Idioma y moneda",
  "managementTabs.planSettings.title": "Opciones de plan",
  "managementTabs.cashbackSettings.title": "Opciones de reembolso en efectivo",
  "managementTabs.membershipSettings.title": "Opciones de participación",
  "managementTabs.updateAndLaunch.title": "Actualizar y lanzar",
  "onboardingTabs.accountSettings.title": "Creación de plan",
  "onboardingTabs.activation.title": "Activación",
  "customerCalcPeriod.options.1.name": "Últimos 30 días",
  "customerCalcPeriod.options.2.name": "Últimos 60 días",
  "customerCalcPeriod.options.3.name": "Últimos 90 días",
  "customerCalcPeriod.options.6.name": "Últimos 6 meses",
  "customerCalcPeriod.options.12.name": "Últimos 12 meses",
  "planType.options.points.name": "Puntos y canjes",
  "planType.options.points_and_benefits.name": "Puntos y beneficios",
  "planType.options.spend.name": "Gastos y beneficios",
  "planType.options.points.tooltip": "Plan basado en puntos con uno o varios niveles y canje de puntos.",
  "planType.options.points_and_benefits.tooltip": "Plan basado en puntos con varios niveles y beneficios sin canje de puntos.",
  "planType.options.spend.tooltip": "Plan basado en el gasto con uno o varios niveles y beneficios sin puntos, pero con reglas de opción de reembolso en efectivo. En un plan basado en gastos solo se gestiona una moneda. Si gestiona varias monedas, deberá gestionar un plan distinto para cada moneda.",
  "pointsAllocatopmDelay.options.1.name": "24 horas",
  "pointsAllocatopmDelay.options.2.name": "48 horas",
  "pointsAllocatopmDelay.options.3.name": "72 horas",
  "pointsAllocatopmDelay.options.7.name": "7 días",
  "pointsAllocatopmDelay.options.14.name": "14 días",
  "pointsAllocatopmDelay.options.21.name": "21 días",
  "pointsAllocatopmDelay.options.30.name": "30 días",
  "pointsAllocatopmDelay.options.40.name": "40 días",
  "tierCalculationType.options.endOfYear.name": " El cálculo de niveles se realiza el 31 de diciembre cada [X años].",
  "tierCalculationType.options.endOfYear.tooltip": "Los niveles se calculan en una fecha fija, cada [x años]. Los miembros que suben a un nivel superior mantienen su estado por el período definido.",
  "tierCalculationType.options.afterJoin.name": "El cálculo de nivel se realiza [X meses] a partir de la fecha de la entrada del miembro al nivel.",
  "tierCalculationType.options.afterJoin.tooltip": "La fecha de cálculo de los niveles puede variar en función de la progresión del miembro en los niveles. Los miembros que pasan a un nivel superior conservan su estado de nivel al menos durante el período definido.",
  "tierCalculationType.options.endOfYear.spend.tooltip": "Cuando se calcula el nivel, se reinicializa el crédito de Loyalty, pero los miembros conservan su estado de nivel hasta el siguiente cálculo.",
  "tierCalculationType.options.noDropout.name": "Los niveles no se calculan. Los miembros no necesitan cumplir requisitos para permanecer en esta categoría.",
  "tierCalculationType.options.noDropout.tooltip": "Los puntos solo se recopilan para subir de nivel.",
  "statusPointsExpirationType.options.tierCalc.name": "Los puntos de estado vencen y se reinicializan en la fecha del cálculo de nivel.",
  "statusPointsExpirationType.options.tierCalc.tooltip": "Cuando se calculan los puntos, se reinicializan, pero los miembros mantienen su estado de nivel hasta el próximo cálculo.",
  "statusPointsExpirationType.options.fromEarn.name": "Los puntos de estado vencen y se reinicializan cada [X meses] desde la fecha en que el miembro gana los puntos.",
  "statusPointsExpirationType.options.fromEarn.tooltip": "Cuando se calculan los niveles, solo se calculan los puntos válidos para ese día. Los miembros mantienen su estado o bajan a un nivel inferior.",
  "statusPointsExpirationType.options.never.name": "Los puntos de estado nunca vencen.",
  "loyaltyCreditExpirationType.options.tiersCalc.name": "El crédito de Loyalty vence y se reinicializa en la fecha en que se calculan los niveles.",
  "loyaltyCreditExpirationType.options.tiersCalc.tooltip": "Cuando se calcula el crédito de Loyalty, se reinicializa, pero los miembros mantienen su estado de nivel hasta el próximo cálculo.",
  "loyaltyCreditExpirationType.options.fromEarn.name": "El crédito de Loyalty vence y se reinicializa cada [X meses] desde la fecha en que el miembro gana el crédito.",
  "loyaltyCreditExpirationType.options.fromEarn.tooltip": "Cuando se calculan los niveles, solo se considera el crédito de Loyalty válido para ese día. Los miembros mantienen su estado o bajan a un nivel inferior.",
  "optIn.options.invitation.name": "Se invita a todos los contactos a unirse al plan de Loyalty.",
  "optIn.options.automatic.name": "Todos los contactos se convierten automáticamente en miembros de Loyalty.",
  "historicalBalancePoints.options.keep.name": "Recompensas con puntos de gasto.",
  "historicalBalancePoints.options.keep.tooltip": "Esta opción incentiva a los miembros a canjear puntos por recompensas.",
  "historicalBalancePoints.options.remove.name": "No recompensar con puntos de gasto.",
  "historicalBalancePoints.options.remove.tooltip": "Los puntos de gasto se reinicializan y los miembros deben ganar nuevos puntos para canjear.",
  "currencyIdentifierSigh.options.symbol.name": "Símbolo de moneda",
  "currencyIdentifierSigh.options.symbol.tooltip": "Ejemplo: $500",
  "currencyIdentifierSigh.options.code.name": "Código de moneda ISO",
  "currencyIdentifierSigh.options.code.tooltip": "Ejemplo: 500USD",
  "currencyIdentifierSigh.options.none.name": "Sin identificador",
  "formStepRewards.options.poolSettings.title": "Opciones del pool",
  "formStepRewards.options.uploadFile.title": "Cargar archivo",
  "formStepRewards.options.redemptionValue.title": "Opciones de oferta",
  "formStepRewards.options.validity.title": "Validez",
  "specialTiers.redemptopmSettings.all.name": "Use las mismas opciones para todos los niveles. Se anularán los valores individuales de nivel.",
  "voucherValidityType.options.unlimited.name": "El vale es válido para un período de tiempo ilimitado.",
  "voucherValidityType.options.limitedFromEarn.name": "El vale es válido durante un periodo de tiempo limitado a partir del momento en que el miembro obtiene el vale.",
  "voucherValidityType.options.fixedDate.name": "El vale es válido durante un período de tiempo predefinido para todos los miembros.",
  "redemptionLimit.options.noLimit.name": "Muestre automáticamente esta oferta a los miembros de manera regular.",
  "redemptionLimit.options.noLimit.tooltip": "Si habilita la opción para un nivel, la oferta de canje se mostrará en el Loyalty Wallet sin restricciones de canje.",
  "redemptionLimit.options.limitMember.name": "Seleccione cuántas veces puede canjear un vale cada miembro durante el período de tiempo definido para esta oferta.",
  "exclusiveAccessExclusivityType.options.name.fixed": "Exclusividad permanente",
  "exclusiveAccessExclusivityType.options.name.limitedTerm": "Exclusividad por tiempo limitado",
  "exclusiveAccessExclusivityType.options.name.limited": "Exclusividad limitada",
  "editorContentTextDefaultValues.tag": "Acceso exclusivo",
  "editorContentTextDefaultValues.firstHeader": "<strong>Adelanto de Black Friday</strong>",
  "editorContentTextDefaultValues.secondHeader": "<strong>REBAJAS</strong>",
  "editorContentTextDefaultValues.middleText": "Ofertas exclusivas de Black Friday para nuestros miembros leales. No se las pierda. Únase al plan de Loyalty ahora.",
  "editorContentTextDefaultValues.actionTopText": "¿Aún no es miembro? Únase a nuestro plan de Loyalty y comience a ganar recompensas.",
  "editorContentTextDefaultValues.leftButton": "Unirse a Loyalty",
  "editorContentTextDefaultValues.rightButton": "Otra hora",
  "editorContentTextDefaultValues.actionBottomText": "<span>¿Ya es miembro? <u>Iniciar de sesión</u></span>",
  "editorContentTextDefaultValues.middleText.mobile": "Ofertas exclusivas para nuestros clientes leales. No se las pierda. Únase al plan de Loyalty ahora.",
  "editorContentTextDefaultValues.actionTopText.mobile": "¿Aún no es miembro? Únase a nuestro programa de Loyalty.",
  "accessUrlType.options.exactUrl.name": "Bloquee y ofrezca acceso exclusivo a esta página:",
  "accessUrlType.options.startsWithUrl.name": "Bloquee y ofrezca acceso exclusivo a todas las páginas que comienzan con esta URL:",
  "formStepsContainer.tierSettings.title": "Opciones del nivel",
  "formStepsContainer.purchaseBenefits.title": "Beneficios de compra",
  "formStepsContainer.visibility.title": "Visibilidad",
  "tierDropout.options.yes.name": "Sí, este nivel se calcula y los miembros deben cumplir los requisitos para permanecer en él.",
  "tierDropout.options.no.name": "No, no existe un escenario de abandono para este nivel.",
  "fixedBenfitType.options.oneTimeVoucher.name": "Vale único",
  "fixedBenfitType.options.fixedYearlyVoucher.name": "Vale anual fijo (se requiere código multiuso).",
  "fixedBenfitType.options.eventAction.name": "Evento",
  "fixedBenfitType.options.exclusiveAccess.name": "Acceso exclusivo",
  "fixedBenfitType.options.custom.name": "Personalizado (proporcionado independientemente por usted)",
  "fixedBenfitType.options.fixedYearlyVoucher.additional.name": "Vale multiuso (se requiere un código multiuso).",
  "tierTypeOptions.regular.name": "Basado en puntos",
  "tierTypeOptions.invite.name": "Solo por invitación",
  "tierTypeOptions.invite.tooltip.learnMoreLinkText": "Más información",
  "tierTypeOptions.invite.tooltip": "Solo los miembros invitados o de pago pueden pertenecer a este nivel. Gestione el pago y la participación por su cuenta. Para agregar un miembro a este nivel, utilice la API de Loyalty o los perfiles de miembros. {learnMoreLink}.",
  "tierTypeOptions.spend.name": "Basado en gastos",
  "exclusiveAccess.cardLabels.permanent": "Permanente",
  "exclusiveAccess.cardLabels.limtedTerm": "Por tiempo limitado",
  "cards.filterBar.moreFiltersButton": "Más filtros",
  "catalogSelector.selected.single": "{items} seleccionado",
  "catalogSelector.selected.multiple": "{items} y {lastItems} seleccionados",
  "iconGallery.uploadResult.failMessage": "Se ha producido algún error durante la carga. Asegúrese de que los archivos cumplen los requisitos. {showFileList,select,true{{failed} de {total} fallidos: {failedDetails}} otro{{failedDetails}}} ",
  "pointsRatesFields.perDescriptor.spend": "para cada",
  "activityElementMultiuplyPointsText.double": "Doble",
  "activityElementMultiuplyPointsText.triple": "Triple"
}
